import { render, staticRenderFns } from "./reg-wallet-2.vue?vue&type=template&id=760c476a&scoped=true&lang=pug&"
import script from "./reg-wallet-2.vue?vue&type=script&lang=js&"
export * from "./reg-wallet-2.vue?vue&type=script&lang=js&"
import style0 from "./reg-wallet-2.vue?vue&type=style&index=0&id=760c476a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c476a",
  null
  
)

export default component.exports